import type { AxiosResponse } from 'axios';
import { Record, type RecordOf } from 'immutable';

import { resourceStoreTypes } from '../core';

export const ENTITLEMENTS_REDUCER_KEY = 'entitlementsStore';
export type ENTITLEMENTS_REDUCER_KEY = typeof ENTITLEMENTS_REDUCER_KEY;

// QCS returns date-only expiresOn/checkAlertsUntil and timestamp expiresAt/partnerExpireAt.
export type EntitlementResponse = {
  id: string;
  expiresAt: string;
  partnerExpireAt?: string | null;
  expiresOn: string;
  checkAlertsUntil: string;
  active: boolean;
};

// Records can be constructed from partial fixtures or legacy cached data.
export type EntitlementProps = Partial<EntitlementResponse>;
export type Entitlement = RecordOf<EntitlementProps>;

export const mkEntitlement = Record<EntitlementProps>({
  id: undefined,
  expiresAt: undefined,
  partnerExpireAt: undefined,
  expiresOn: undefined,
  checkAlertsUntil: undefined,
  active: undefined,
});

export type EntitlementsStore = resourceStoreTypes.QcsSyncResourceStore<EntitlementProps>;
export const mkEntitlementsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<EntitlementProps>();

export type CreateEntitlementRequest = {
  deviceId: { [key: string]: string };
  applicationId: { [key: string]: string };
  partnerSubscriptionDetails: {
    partnerName: string;
    partnerUserIdentifier?: string | number;
    partnerSubscriptionArtifact?: string;
    partnerTransactionArtifact?: string;
    partnerRenewalArtifact?: string;
    partnerAdditionDetailsMap?: { [key: string]: unknown };
  };
};

export type EntitlementsResponse = { entitlements: EntitlementResponse[] };
export type CreateEntitlementResponse = AxiosResponse<EntitlementsResponse, CreateEntitlementRequest> & {
  resource: Entitlement[];
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ENTITLEMENTS_REDUCER_KEY]: EntitlementsStore;
  }
}
